var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 20.4V13.8H5.02701C5.67843 16.3305 7.66944 18.3216 10.2 18.973V21.2H3.6C3.15815 21.2 2.8 20.8419 2.8 20.4Z",
    stroke: "#F46857",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9994 21.9506C18.0527 21.4489 21.9994 17.1853 21.9994 12C21.9994 6.47715 17.5222 2 11.9994 2C6.8141 2 2.55055 5.94668 2.04883 11H5.67712C6.1572 7.94037 8.80501 5.6 11.9994 5.6C15.534 5.6 18.3994 8.46538 18.3994 12C18.3994 15.1944 16.059 17.8422 12.9994 18.3223V21.9506Z",
    fill: "#F46857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOrange);
export default __webpack_public_path__ + "static/media/LogoOrange.1dac67ae0f1bd92089e786200a57671a.svg";
export { ForwardRef as ReactComponent };